import { useMemo } from "react";
import type { ICountryObject } from "app/services/CountryService";
import CountryService from "app/services/CountryService";

type HookParams = ReadonlyArray<Readonly<ICountryObject>>;

type HookReturnValue = ReadonlyArray<Readonly<ICountryObject>>;

export default function useCountriesWithoutWW(countries: HookParams): HookReturnValue {
    return useMemo(() => {
        return countries.filter(({ id }) => !CountryService.isWorldwideCountry(id));
    }, [countries]);
}
